var _g, _title, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLocal = function SvgLocal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 6.5",
    style: {
      enableBackground: "new 0 0 16 6.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M4.2,0.1L4,0.4C3.9,0.5,3.9,0.6,3.9,0.7l0,0c0,0.1,0,0.2,0.1,0.3l0,0l1.7,1.7H0.4 C0.2,2.6,0,2.8,0,3.1l0,0v0.4c0,0.2,0.2,0.4,0.4,0.4l0,0l0,0h5.2L4,5.5C3.9,5.6,3.9,5.7,3.9,5.8l0,0c0,0.1,0,0.2,0.1,0.3l0,0 l0.3,0.3c0.1,0.1,0.2,0.1,0.3,0.1l0,0c0.1,0,0.2,0,0.3-0.1l0,0l2.8-2.8c0.1-0.1,0.1-0.2,0.1-0.3l0,0c0-0.1,0-0.2-0.1-0.3l0,0 L4.8,0.1C4.8,0,4.7,0,4.5,0l0,0C4.4,0,4.3,0,4.2,0.1L4.2,0.1z M11.2,0.1L8.4,2.9C8.3,3,8.2,3.1,8.2,3.2l0,0c0,0.1,0,0.2,0.1,0.3 l0,0l2.8,2.8c0.1,0.1,0.2,0.1,0.3,0.1l0,0c0.1,0,0.2,0,0.3-0.1l0,0L12,6.1c0.1-0.1,0.1-0.2,0.1-0.3l0,0c0-0.1,0-0.2-0.1-0.3l0,0 l-1.6-1.7h5.2c0.2,0,0.4-0.2,0.4-0.4l0,0V3c0-0.2-0.2-0.4-0.4-0.4l0,0l0,0h-5.2L12,1c0.1-0.1,0.1-0.2,0.1-0.3l0,0 c0-0.1,0-0.2-0.1-0.3l0,0l-0.3-0.3C11.7,0,11.6,0,11.5,0l0,0C11.3,0,11.2,0,11.2,0.1L11.2,0.1z"
  }))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\n\t\tLocal Call Icon\n\t")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recent-calls-Filter",
    transform: "translate(-22.000000, -591.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(0.000000, 398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(0.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24-Copy-2",
    transform: "translate(22.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    fill: "currentColor",
    d: "M4.2,0.1L4,0.4C3.9,0.5,3.9,0.6,3.9,0.7l0,0c0,0.1,0,0.2,0.1,0.3l0,0l1.7,1.7H0.4 C0.2,2.6,0,2.8,0,3.1l0,0v0.4c0,0.2,0.2,0.4,0.4,0.4l0,0l0,0h5.2L4,5.5C3.9,5.6,3.9,5.7,3.9,5.8l0,0c0,0.1,0,0.2,0.1,0.3 l0,0l0.3,0.3c0.1,0.1,0.2,0.1,0.3,0.1l0,0c0.1,0,0.2,0,0.3-0.1l0,0l2.8-2.8c0.1-0.1,0.1-0.2,0.1-0.3l0,0 c0-0.1,0-0.2-0.1-0.3l0,0L4.8,0.1C4.8,0,4.7,0,4.5,0l0,0C4.4,0,4.3,0,4.2,0.1L4.2,0.1z M11.2,0.1L8.4,2.9 C8.3,3,8.2,3.1,8.2,3.2l0,0c0,0.1,0,0.2,0.1,0.3l0,0l2.8,2.8c0.1,0.1,0.2,0.1,0.3,0.1l0,0c0.1,0,0.2,0,0.3-0.1l0,0L12,6.1 c0.1-0.1,0.1-0.2,0.1-0.3l0,0c0-0.1,0-0.2-0.1-0.3l0,0l-1.6-1.7h5.2c0.2,0,0.4-0.2,0.4-0.4l0,0V3c0-0.2-0.2-0.4-0.4-0.4l0,0 l0,0h-5.2L12,1c0.1-0.1,0.1-0.2,0.1-0.3l0,0c0-0.1,0-0.2-0.1-0.3l0,0l-0.3-0.3C11.7,0,11.6,0,11.5,0l0,0 C11.3,0,11.2,0,11.2,0.1L11.2,0.1z"
  })))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/local.401a6063.svg";
export { ForwardRef as ReactComponent };